export const PaymentsFilterTabs = {
    Successful: 'Sent',
    Refunded: 'Refunded',
    All: 'all'
};
